export var DateInputInteractionMode = /*#__PURE__*/function (DateInputInteractionMode) {
  DateInputInteractionMode["None"] = "none";
  DateInputInteractionMode["Caret"] = "caret";
  DateInputInteractionMode["Selection"] = "selection";
  return DateInputInteractionMode;
}(DateInputInteractionMode || {});